import request from '@/router/axios'
import {VUE_APP_API_CONTEXT_PATH} from '@/utils/env'

const baseUrl = VUE_APP_API_CONTEXT_PATH + '/v1/course/'

export function courseList (query) {
  return request({
    url: baseUrl + 'userCourseList',
    method: 'get',
    params: query
  })
}

export function addSectionFinish (params) {
  return request({
    url: VUE_APP_API_CONTEXT_PATH + '/v1/member/knowledge/point/update/all',
    method: 'put',
    data: params
  })
}
export function getlivesList (query) {
  return request({
    url: VUE_APP_API_CONTEXT_PATH + '/lives/list',
    method: 'get',
    params: query
  })
}
export function getlivesDetail (id) {
  return request({
    url: VUE_APP_API_CONTEXT_PATH + '/lives/detail',
    method: 'get',
    params: {id}
  })
}
export function getlivesStream(params) {
  return request({
    url: VUE_APP_API_CONTEXT_PATH + '/live/stream/page',
    method: 'get',
    params: params
  })
}
export function alreadCourseList (query) {
  return request({
    url: baseUrl + 'already/study',
    method: 'get',
    params: query
  })
}
export function checkCourseStatus(id) {
  return request({
    url: baseUrl + 'checkCourseStatus',
    method: 'get',
    params: {id}
  })
}
export function getProgress (query) {
  return request({
    url: baseUrl + 'study/progress',
    method: 'get',
    params: query
  })
}
export function getExamined (query) {
  return request({
    url: baseUrl + 'studied/examined',
    method: 'get',
    params: query
  })
} 
export function getCertificate (query) {
  return request({
    url: baseUrl + 'certificate',
    method: 'get',
    params: query
  })
} 
export function categoryTree (query) {
  return request({
    url: VUE_APP_API_CONTEXT_PATH + '/v1/courseCategory/categoryTree',
    method: 'get',
    params: query
  })
}
export function popularCourses (query) {
  return request({
    url: baseUrl + 'popularCourses',
    method: 'get',
    params: query
  })
}

export function getObj (id) {
  return request({
    url: baseUrl + id,
    method: 'get'
  })
}
export function getReport (courseId) {
  return request({
    url: baseUrl + 'study/report',
    method: 'get',
    params:{
      courseId
    }
  })
}
export function addObj (obj) {
  return request({
    url: baseUrl,
    method: 'post',
    data: obj
  })
}

export function putObj (obj) {
  return request({
    url: baseUrl,
    method: 'put',
    data: obj
  })
}

export function delObj (id) {
  return request({
    url: baseUrl + id,
    method: 'delete'
  })
}

export function delAllObj (obj) {
  return request({
    url: baseUrl + 'deleteAll',
    method: 'post',
    data: obj
  })
}

export function getCourseDetail (id,flag) {
  return request({
    url: baseUrl + 'detail/' + id+'?isOpen=' + flag,
    method: 'get'
  })
}

export function joinCourse (id) {
  return request({
    url: baseUrl + id + '/join',
    method: 'post'
  })
}

export function isReStart (id) {
  return request({
    url: baseUrl + id + '/is/restart',
    method: 'post'
  })
}

export function getCourseAttach (id) {
  return request({
    url: baseUrl + id + '/attach',
    method: 'get'
  })
}

export function favoriteCourse (id, userId, type) {
  return request({
    url: VUE_APP_API_CONTEXT_PATH + '/v1/favorites/favCourse/' + id + '?userId=' + userId + '&type=' + type,
    method: 'post'
  })
}



// WEBPACK FOOTER //
// ./src/api/exam/course.js